// src/pages/CalendarPage/EventTableUser.jsx
import React from "react";
import { FaCalendarAlt, FaMapMarkerAlt } from "react-icons/fa";

const EventTableUser = ({ events, onEventClick }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return isNaN(date)
      ? ""
      : date.toLocaleDateString("fr-FR", {
          day: "numeric",
          month: "long",
          year: "numeric",
        });
  };

  if (!events || events.length === 0) {
    return null;
  }

  return (
    <div className="mt-4 max-w-6xl mx-auto">
      <div className="overflow-x-auto rounded-2xl border border-slate-200 dark:border-slate-700 bg-white/95 dark:bg-slate-900/95 shadow-lg">
        <table className="min-w-full text-sm text-left">
          <thead className="bg-slate-50 dark:bg-slate-800/90">
            <tr>
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 dark:text-slate-300 uppercase tracking-[0.16em]">
                Événement
              </th>
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 dark:text-slate-300 uppercase tracking-[0.16em]">
                Date
              </th>
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 dark:text-slate-300 uppercase tracking-[0.16em]">
                Lieu
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200 dark:divide-slate-700">
            {events.map((event) => {
              const start = formatDate(event.start);
              const end = event.end ? formatDate(event.end) : "";
              const photo =
                event.photo_url || "/img/default_image.jpg";

              return (
                <tr
                  key={event.id}
                  className="cursor-pointer hover:bg-slate-50/90 dark:hover:bg-slate-800/80 transition-colors"
                  onClick={() => onEventClick(event)}
                >
                  <td className="px-4 py-3 align-middle">
                    <div className="flex items-center gap-3">
                      <div className="w-14 h-14 rounded-lg overflow-hidden bg-slate-200 dark:bg-slate-700 flex-shrink-0">
                        <img
                          src={photo}
                          alt={event.titre}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div>
                        <p className="font-semibold text-slate-900 dark:text-white text-sm">
                          {event.titre}
                        </p>
                        {event.type_event && (
                          <p className="text-[11px] text-slate-500 dark:text-slate-400">
                            {event.type_event} · {event.level_event}
                          </p>
                        )}
                        {event.cate_event && (
                          <p className="text-[11px] text-slate-400 dark:text-slate-500">
                            {event.cate_event}
                          </p>
                        )}
                      </div>
                    </div>
                  </td>
                  <td className="px-4 py-3 align-middle text-slate-700 dark:text-slate-200">
                    <div className="flex items-center gap-2">
                      <FaCalendarAlt className="text-xs text-slate-400" />
                      <span className="text-xs">
                        {start}
                        {end && ` – ${end}`}
                      </span>
                    </div>
                  </td>
                  <td className="px-4 py-3 align-middle text-slate-700 dark:text-slate-200">
                    <div className="flex items-center gap-2">
                      <FaMapMarkerAlt className="text-xs text-slate-400" />
                      <span className="text-xs">
                        {event.lieu_event || "Lieu à préciser"}
                      </span>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EventTableUser;
